import React from 'react';
import { MaskIcon } from '@/app/common/icons/MaskIcon';

import type { StarfishIconRef } from '@/app/common/icons/starfish';

// Indexed by meal plan value 0-5: any, room only, breakfast, half board, full board, all inclusive.
const MEAL_PLAN_ICONS: StarfishIconRef<'Food and beverages'>[] = [
  { category: 'Food and beverages', name: 'icon-cutlery' },
  { category: 'Food and beverages', name: 'icon-slashed-cutlery' },
  { category: 'Food and beverages', name: 'icon-breakfast' },
  { category: 'Food and beverages', name: 'icon-half-board' },
  { category: 'Food and beverages', name: 'icon-full-board' },
  { category: 'Food and beverages', name: 'icon-all-inclusive' },
];

const drawAt = (size: number) => MEAL_PLAN_ICONS.map((icon) => <MaskIcon key={icon.name} {...icon} size={size} />);

export const [ICON_ANY, ICON_ROOM_ONLY, ICON_BREAKFAST, ICON_HALF_BOARD, ICON_FULL_BOARD, ICON_ALL_INCLUSIVE] =
  drawAt(24);

// Here rather than in getMealPlanField, so an evo caller does not pull the legacy vertical-filters
// module in with it.
const EVO_MEAL_PLAN_ICONS = drawAt(20);

export const getMealPlanEvoIcon = () => EVO_MEAL_PLAN_ICONS;
